(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-estimator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pfEstReady === 'true') return;
      root.dataset.pfEstReady = 'true';

      var summaryEl = root.querySelector('[data-pf-est-summary]');
      var noteEl = root.querySelector('[data-pf-est-note]');
      var sendBtn = root.querySelector('[data-pf-est-send]');

      function val(kind) {
        var el = root.querySelector('[data-pf-est="' + kind + '"]:checked');
        return el ? el.value : '';
      }
      function multi(kind) {
        return Array.prototype.slice
          .call(root.querySelectorAll('[data-pf-est="' + kind + '"]:checked'))
          .map(function (e) { return e.value; });
      }

      /* Guidance, not pricing. Every line below is a statement about what we
         would look at, never about what it costs. */
      function guidance(building, scopes, existing) {
        var out = [];
        if (building.indexOf('metal building') > -1 || building.indexOf('barndominium') > -1) {
          out.push('On a steel building the usual answer is closed-cell against the underside of the panel, over the purlins rather than between them, because condensation is normally the real problem rather than temperature.');
        }
        if (building.indexOf('slab') > -1) {
          out.push('Slab and flatwork lifting is quoted by area once we have established what is under it. It is not foundation repair, and we will tell you if that is what you actually have.');
        }
        if (scopes.indexOf('The attic') > -1) {
          out.push('For an attic, the first thing we establish is whether your ductwork is up there. If it is, sealing the roofline usually does more than adding depth to the attic floor.');
        }
        if (scopes.indexOf('Under the floor or crawl space') > -1) {
          out.push('Under a floor we assess drainage and ground cover before quoting anything. Sealing a crawl space that still has a moisture source makes it worse, not better.');
        }
        if (scopes.indexOf('The walls') > -1) {
          out.push('Walls can only take spray foam while the cavity is open. On a finished wall the option is dense-pack blown-in instead.');
        }
        if (existing.indexOf('Old blown-in') > -1 || existing.indexOf('Batt') > -1 || existing.indexOf('Vinyl-faced') > -1) {
          out.push('Existing material may need to come out first. We quote removal as its own line so you can see what it costs separately.');
        }
        if (!out.length) {
          out.push('We will walk the building with you and tell you which of these is worth doing first, and which is not worth doing at all.');
        }
        return out.slice(0, 3).join(' ');
      }

      function render() {
        var building = val('building');
        var scopes = multi('scope');
        var size = val('size');
        var existing = val('existing');

        var scopeText = scopes.length ? scopes.join(', ').toLowerCase() : 'not decided yet';
        var text = building + '. Work needed: ' + scopeText + '. Size: ' + size + '. Currently: ' + existing.toLowerCase() + '.';

        summaryEl.textContent = text;
        noteEl.textContent = guidance(building, scopes, existing);
        root.dataset.pfEstText = text + '\n\n' + noteEl.textContent;
      }

      /* :has() covers modern browsers; the class keeps the checked state
         visible anywhere it is missing. */
      function marks() {
        root.querySelectorAll('.pf-est__opt').forEach(function (label) {
          var input = label.querySelector('input');
          label.classList.toggle('is-checked', !!(input && input.checked));
        });
      }

      root.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute('data-pf-est')) { render(); marks(); }
      });

      if (sendBtn) {
        sendBtn.addEventListener('click', function () {
          var body = document.querySelector('.pf-form [name="contact[body]"]');
          if (!body) { window.location.href = '/pages/contact'; return; }
          var pre = root.dataset.pfEstText || '';
          body.value = pre + (body.value ? '\n\n' + body.value : '');
          var form = body.closest('.pf-form') || body;
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { body.focus({ preventScroll: true }); }, 420);
        });
      }

      render();
      marks();
    }

    function boot() {
      document.querySelectorAll('[data-pf-estimator]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-nav"]) return;
  try {
    
  (function () {
    var DESK = window.matchMedia('(min-width: 1100px)');
    var globalsWired = false;

    function currentRoot() { return document.querySelector('[data-pf-nav]'); }
    function itemsOf(root) { return root ? root.querySelectorAll('.pf-menu__item--has') : []; }
    function unlock() { document.documentElement.style.overflow = ''; }

    function setOpen(item, open) {
      var tog = item.querySelector('[data-pf-tog]');
      var panel = item.querySelector('[data-pf-panel]');
      if (!tog || !panel) return;
      item.classList.toggle('open', open);
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { panel.hidden = false; }
      else {
        window.setTimeout(function () {
          if (!item.classList.contains('open')) panel.hidden = true;
        }, 220);
      }
    }

    function closeAll(root, except) {
      Array.prototype.forEach.call(itemsOf(root), function (i) {
        if (i !== except) setOpen(i, false);
      });
    }

    function openItem(root) {
      var list = itemsOf(root);
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('open')) return list[i];
      }
      return null;
    }

    function focusables(drawer) {
      if (!drawer) return [];
      var list = drawer.querySelectorAll('a[href], summary, button:not([disabled])');
      return Array.prototype.filter.call(list, function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    /* The drawer is fixed to the viewport, so its top padding has to clear the
       header wherever the header currently sits. Measured, not assumed. */
    function padDrawer(root) {
      var drawer = root && root.querySelector('[data-pf-drawer]');
      var bar = root && root.querySelector('.pf-nav');
      if (!drawer || !bar) return;
      var bottom = Math.round(bar.getBoundingClientRect().bottom);
      if (!(bottom > 0)) bottom = 76;
      drawer.style.paddingTop = (bottom + 20) + 'px';
    }

    function measure(root) {
      var bar = root && root.querySelector('.pf-nav');
      if (!bar) return;
      document.documentElement.style.setProperty('--header-height', Math.round(bar.getBoundingClientRect().height) + 'px');
    }

    function setDrawer(root, open) {
      if (!root) return;
      var burger = root.querySelector('[data-pf-burger]');
      var drawer = root.querySelector('[data-pf-drawer]');
      if (!burger || !drawer) return;
      var was = !drawer.hidden;
      if (open) padDrawer(root);
      drawer.hidden = !open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      root.classList.toggle('dopen', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        var f = focusables(drawer)[0];
        if (f) f.focus({ preventScroll: true });
      } else if (was) {
        burger.focus({ preventScroll: true });
      }
    }

    /* Wired once for the life of the page. Every handler resolves the header at
       call time, so a section re-render in the theme editor swaps the DOM
       underneath them without leaving a stale reference or a duplicate listener. */
    function wireGlobals() {
      if (globalsWired) return;
      globalsWired = true;

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.key !== 'Escape') return;
        var root = currentRoot();
        if (!root) return;
        var drawer = root.querySelector('[data-pf-drawer]');

        if (e.key === 'Tab') {
          if (!drawer || drawer.hidden) return;
          var stops = focusables(drawer);
          var burger = root.querySelector('[data-pf-burger]');
          if (burger) stops = stops.concat([burger]);
          if (!stops.length) return;
          var first = stops[0];
          var last = stops[stops.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          return;
        }

        var open = openItem(root);
        if (open) {
          var tog = open.querySelector('[data-pf-tog]');
          setOpen(open, false);
          if (tog) tog.focus();
          return;
        }
        if (drawer && !drawer.hidden) setDrawer(root, false);
      });

      document.addEventListener('click', function (e) {
        var root = currentRoot();
        if (root && !root.contains(e.target)) closeAll(root, null);
      });

      DESK.addEventListener('change', function (e) {
        var root = currentRoot();
        if (!root) return;
        if (e.matches) setDrawer(root, false); else closeAll(root, null);
      });

      window.addEventListener('resize', function () {
        var root = currentRoot();
        if (!root) return;
        measure(root);
        var drawer = root.querySelector('[data-pf-drawer]');
        if (drawer && !drawer.hidden) padDrawer(root);
      });

      /* Editor lifecycle. Releasing the lock on every one of these is the point:
         a re-render while the drawer was open would otherwise leave the preview
         scroll-locked below the header, which reads as a missing menu. */
      document.addEventListener('shopify:section:load', function () { unlock(); boot(); });
      document.addEventListener('shopify:section:unload', function () { unlock(); });
      document.addEventListener('shopify:section:select', function () { unlock(); boot(); });
      document.addEventListener('shopify:section:deselect', function () { unlock(); });
      document.addEventListener('shopify:block:select', function () { unlock(); });
    }

    function init(root) {
      if (!root) return;
      wireGlobals();
      if (root.dataset.ready === '1') { measure(root); return; }
      root.dataset.ready = '1';

      /* A fresh render always starts closed and unlocked. */
      root.classList.remove('dopen');
      unlock();

      var timer = null;

      Array.prototype.forEach.call(itemsOf(root), function (item) {
        var tog = item.querySelector('[data-pf-tog]');
        if (tog) {
          tog.addEventListener('click', function (e) {
            e.preventDefault();
            var open = !item.classList.contains('open');
            closeAll(root, item); setOpen(item, open);
          });
        }
        item.addEventListener('mouseenter', function () {
          if (!DESK.matches) return;
          window.clearTimeout(timer); closeAll(root, item); setOpen(item, true);
        });
        item.addEventListener('mouseleave', function () {
          if (!DESK.matches) return;
          timer = window.setTimeout(function () { setOpen(item, false); }, 170);
        });
        item.addEventListener('focusout', function (e) {
          if (item.contains(e.relatedTarget)) return;
          setOpen(item, false);
        });
      });

      var burger = root.querySelector('[data-pf-burger]');
      var drawer = root.querySelector('[data-pf-drawer]');

      if (drawer) {
        var dgs = drawer.querySelectorAll('[data-pf-dg]');
        Array.prototype.forEach.call(dgs, function (dg) {
          dg.addEventListener('toggle', function () {
            if (!dg.open) return;
            Array.prototype.forEach.call(dgs, function (other) { if (other !== dg) other.open = false; });
          });
        });
        drawer.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('a[href]')) setDrawer(root, false);
        });
      }

      if (burger) {
        burger.addEventListener('click', function () {
          setDrawer(root, !!(drawer && drawer.hidden));
        });
      }

      var bar = root.querySelector('.pf-nav');
      if (bar && 'ResizeObserver' in window) {
        new ResizeObserver(function () { measure(root); }).observe(bar);
      }
      measure(root);
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-pf-nav]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    wireGlobals();
  })();

  } catch(e) { console.error(e); }
})();
})();
